export var Role;
(function (Role) {
    Role["OWNER"] = "owner";
    Role["ADMIN"] = "admin";
    Role["EDITOR"] = "editor";
    Role["VIEWER"] = "viewer";
    // Platform-level roles (users linked to platform tenant)
    Role["PLATFORM_ADMIN"] = "platform_admin";
    Role["PLATFORM_MANAGER"] = "platform_manager";
    Role["PLATFORM_DATA_ADMIN"] = "platform_data_admin";
    Role["PLATFORM_USER"] = "platform_user";
})(Role || (Role = {}));
/** Check if a role is a platform-level role */
export function isPlatformRole(role) {
    return role.startsWith('platform_');
}
//# sourceMappingURL=auth.js.map